<app-login-content-container>
  <div class="layout">
    <!-- <img src="assets/images/forgot_password.png" /> -->

    <!-- <form class="login-form p-3" [formGroup]="forgotFormGrp"> -->
    <form class="login-form" [formGroup]="forgotFormGrp">
      <div class="align-center">
        @if (firstTimeUser) {
          <h2>{{ "login.set_password" | translate }}</h2>
        }
        @if (!firstTimeUser) {
          <h2>{{ "login.forgotPassword" | translate }}</h2>
        }
      </div>
      @if (errorMessage) {
        <div class="error-container" style="width: 100%">
          {{ this.errorMessage }}
        </div>
      }
      <div class="div-info">
        @if (firstTimeUser) {
          <span>
            {{ "forgot_password.sent_email_to_set_pwd_msg" | translate }}
          </span>
        }
        @if (!firstTimeUser) {
          <span>
            {{ "forgot_password.sent_email_to_reset_pwd_msg" | translate }}
          </span>
        }
      </div>

      <mat-form-field class="align-self-center" [ngStyle]="{
                          'margin-bottom': forgotFormGrp.get('email')?.hasError('email') ? '25px' : '0'
                        }" style="width: 100%; margin-top: 25px;" appearance="outline">
        <mat-label>{{ "common.email_address" | translate }}</mat-label>
        <input [uwFocus]="true" matInput type="email" autocomplete="off" formControlName="email"
          placeholder="Ex. pat@example.com" />

          <mat-error *ngIf="!forgotFormGrp.get('email')?.hasError('required') || forgotFormGrp.get('email')?.hasError('email')">{{ "login.please_enter_valid_email" | translate }}</mat-error>
        </mat-form-field>

        <div class="flex-column-center">
          <uw-button
            [loading]="buttonLoading"
            (click)="executeForgotPasswordByUserLoginType()"
            btnLabel=" {{ 'forgot_password.send_request' | translate }}"
          ></uw-button>
          <button
            [title]="'forgot_password.return_to_sign_in' | translate"
            mat-button
            [uwRouterLink]="['/main/login']"
            >
            {{ "forgot_password.return_to_sign_in" | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-login-content-container>
